import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Box, Button, Divider, Tabs, Typography } from 'shared/ui'
import { type IParamsEnhancePrompt } from 'entities/Chatbot'
import { type AdvancedSettingsStore } from 'pages/chatbot/pages/agentBookAppointment/store/advancedSettingsStore'
import styles from './styles.module.scss'
import { GeneralSettings } from './GeneralSettings'
import { PromptSettings } from './PromptSettings'

export type IAdvancedSettingsProps = {
  advancedSettingsStore: AdvancedSettingsStore
  getEnhancePromptData: (instructions: string, id: number) => IParamsEnhancePrompt
  id: number | null
}

export const AdvancedSettingsModal = observer(
  ({ advancedSettingsStore, getEnhancePromptData, id }: IAdvancedSettingsProps) => {
    const {
      tabs,
      activeTabKey,
      setActiveTabKey,
      handleCancel,
      handleSaveSettings,
      promptSettingsStore: { reachMaxLength, instructions },
    } = advancedSettingsStore
    const promptData = getEnhancePromptData(instructions, id ?? 0)
    const { clientHeight } = window?.document?.documentElement

    return (
      <>
        <div className={classNames(styles.wrapper, { [styles.smallScreen]: clientHeight < 880 })}>
          <div>
            <Typography variant={'heading-md'} ariaLabel={'title'}>
              Customize
            </Typography>
            <div className={styles.tabs}>
              <Tabs
                variant={'simpleWithoutBorder'}
                tabs={tabs}
                activeTabKey={activeTabKey}
                handleSelectTab={({ key }) => setActiveTabKey(key)}
              />
              <Divider style={{ marginTop: '8px' }} />
            </div>
          </div>
          <div className={styles.content}>
            {activeTabKey === 'general' && <GeneralSettings settings={advancedSettingsStore} />}
            {activeTabKey === 'prompt' && (
              <PromptSettings settings={advancedSettingsStore} promptData={promptData} />
            )}
          </div>
        </div>
        <Box display={'flex'} gap={1} marginTop={2} marginLeft={'24px'} marginBottom={3}>
          <Button
            text={'Save'}
            contained={'primary'}
            size={'medium'}
            onClick={handleSaveSettings}
            disabled={reachMaxLength}
          />
          <Button text={'Cancel'} contained={'secondary'} size={'medium'} onClick={handleCancel} />
        </Box>
      </>
    )
  }
)
